export default {
  text: `    Good game, good wood, me chop wood. Have many wood now. Me go chop wood now.`,
  author: "Andy",
  authorTitle: "The Carpenter"
};
